import React from 'react';
import { withTranslation } from 'react-i18next';
import config from '../../config';

import Button from '../../components/commons/Button';
import slide0 from '../../assets/img/img-wizard-1.png';
import slide1 from '../../assets/img/img-wizard-2.png';
import slide2 from '../../assets/img/img-wizard-3.png';
import slide3 from '../../assets/img/img-wizard-4.png';
import { connect } from 'react-redux';

const images = Object.freeze({ slide0, slide1, slide2, slide3 });
class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      slide: 0,
      slides: null,
      content: []
    }
  }
  
  componentDidMount() {
    console.log('Slider PAGE', config.SLIDER.CONTENT);
    const modeApp = this.props.mode_app_settings?.item?.value || "normal";
    // debugger
    this.setState({ slides: config.SLIDER[modeApp].CONTENT.length, content: config.SLIDER[modeApp].CONTENT });
  }
 
  onPressButtonPrev = () => {
    let slide = this.state.slide;
    if (slide > 0) slide--;
    this.setState({ slide });
  };

  onPressButtonNext = () => {
    let slide = this.state.slide;
    if (slide < this.state.slides -1)  {
      slide++;
      this.setState({ slide });
    } else {
      localStorage.setItem(config.SLIDER_SCREEN, JSON.stringify(false));
      this.props.close(false);
    }
  };  

  render() {
    const { slide, content } = this.state
    if (content.length === 0) return null;
    return (
      <main className="h-full text-center p-10 bg-white">
        <div className="container max-w-md mx-auto h-full w-full flex flex-col items-center justify-around md:justify-start">
          {content.length !== 0 ? (
            <>
              <div className="h-80 md:h-96 flex items-center">
                <img src={images[`slide${slide}`]} alt="" />
              </div>
              <div>
                <h1 className="text-primary mb-5">{this.t(content[slide].title)}</h1>
                <p className="text-gray-600 mb-10">{this.t(content[slide].body)}</p>
              </div>
              <Button
                className="btn-block btn-primary"
                title={this.t(content[slide].button)}
                onClick={this.onPressButtonNext}
              />
            </>
          ) : (
            <Button
              className="btn-block btn-primary"
              title={this.t("Start")}
              onClick={() => this.props.close(false)}
            />
          )}
        </div>
      </main>
    ) 
  }
}
const mapStateToProps = state => {
  return {
    mode_app_settings: state.settings.appmode,
  };
};


export default connect(mapStateToProps,null)(withTranslation()(Slider));
